import React, { createContext, useState, useContext } from "react";

const QuizContext = createContext();

export const useQuizContext = () => {
  return useContext(QuizContext);
};

export const QuizProvider = ({ children }) => {
  const [canAttemptQuiz, setCanAttemptQuiz] = useState(false);
  const [quizStarted, setQuizStarted] = useState(false); // Track if quiz has started

  const allowQuizAttempt = () => {
    setCanAttemptQuiz(true);
    setQuizStarted(true);
  };

  const resetQuizAttempt = () => {
    setCanAttemptQuiz(false);
    setQuizStarted(false);
  };

  return (
    <QuizContext.Provider
      value={{
        canAttemptQuiz,
        quizStarted,
        allowQuizAttempt,
        resetQuizAttempt,
      }}
    >
      {children}
    </QuizContext.Provider>
  );
};
